import { render, staticRenderFns } from "./NursingHomes.vue?vue&type=template&id=08cb6c60&"
import script from "./NursingHomes.vue?vue&type=script&lang=js&"
export * from "./NursingHomes.vue?vue&type=script&lang=js&"
import style0 from "./NursingHomes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports